export default function UITitle({ style,children, className, h1 = false, h2 = false, h3 = false, h4 = false, h5 = false, h6 = false }) {
    return (
        <div className={`
        font-BNPPSquareBold
        ${h1 && 'text-2xl  font-bold my-2 text-gray-800'} 
        ${h2 && 'text-[26px] leading-tight md:text-[42px] font-bold my-2 text-green-600'} 
        ${h3 && 'text-2xl font-bold my-2 text-gray-800'} 
        ${h4 && 'text-[22px] font-bold text-gray-800'} 
        ${h5 && 'text-[16px] font-bold my-2 text-gray-800'} 
        ${className}`} style={{...style}}>
            {children}
        </div>
    )
}